import AppConstant from '../../../../config/app.constants'
import _ from 'lodash';

class MonthlyReportController {
    /*@ngInject*/
    constructor(Auth, $state, User, SetupService, MonthlyReportService, DateUtil, $translate, $location, $q, Modal, $scope, $rootScope) {
        this.$rootScope = $rootScope;
        this.model = {
            startVaultDate: "",
            endVaultDate: "",
            branch: User.getUser().branchId,
            monthlyReport: [],
            search: "",
            dateRange: {
                startDate: null,
                endDate: null
            },
        }
        this.MonthlyReportService = MonthlyReportService;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$q = $q;
        this.sortColumn = "vaultDate";
        this.reverseSort = false;
        this.reportPrefix = 'MonthlyReport';
        this.Modal = Modal;

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: AppConstant.defaultPageLimit,
            maxPages: 10
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/monthly-report');
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};

        [].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey)

            this.hasACL[permissionKey] = {};

            this.acl[permissionKey].forEach((permission) => {
                this.hasACL[permissionKey][permission] = true;
            });
        });
    }

    setDateRange(date) {
        let currentVaultDate = date || moment();
        this.model.dateRangPickerOptions = {
            autoApply: true,
            maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.pagination.page = 1;
                    this.generateReport(this.model.dateRange);
                }
            },
            ranges: {
                'Today': [
                    moment(currentVaultDate).format('YYYY-MM-DD'),
                    moment(currentVaultDate).format('YYYY-MM-DD')
                ],
                'Current Week': [
                    moment(currentVaultDate).startOf('week').format('YYYY-MM-DD'),
                    moment(currentVaultDate).endOf('week').format('YYYY-MM-DD')
                ],
                'Current Month': [
                    moment(currentVaultDate).startOf('month').format('YYYY-MM-DD'),
                    moment(currentVaultDate).endOf('month').format('YYYY-MM-DD')
                ]
            }
        }
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.branch)
        ])
            .then((data) => {
                this.currentVaultDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
                this.vaultDate = moment(this.currentVaultDate).format('YYYY-MM-DD')
                this.setDateRange(this.vaultDate);
                this.model.dateRange.startDate = moment(this.currentVaultDate).format('YYYY-MM-DD');
                this.model.dateRange.endDate = moment(this.currentVaultDate).endOf('day').format('YYYY-MM-DD');
            })
            .then(() => {
                this.loadPermission();
                this.generateReport();
            })
            .catch((err) => {
                console.log(err)
            })
    }

    generateReport(date) {
        this.startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD');
        this.endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD');
        this.model.loading = true;

        this.MonthlyReportService.getMonthlyReport(this.startDate, this.endDate, this.model.search, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.model.loading = false;
                this.model.monthlyReport = data.results;
                this.pagination.total = data.totalRecord;
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    pageChange() {
        this.generateReport();
    }

    search() {
        this.pagination.page = 1;
        this.generateReport();
    }

    SortData(column) {
        this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
        this.sortColumn = column;
    }

    // export data to CSV file
    exportToCSV() {
        let startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD');
        let endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD');
        this.loading = true;
        this.MonthlyReportService.exportDataToCSV(this.model.search, startDate, endDate, 0 , 200000)
            .then((data) => {
                this.date = moment.utc().format('DDMMYY');
                this.fileName = this.reportPrefix.concat('_', this.date, '.csv');
                let a = document.createElement("a");
                document.body.appendChild(a);
                let file = new Blob([data.reportData], { type: 'application/csv' });
                let fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = this.fileName;
                a.click();
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
                console.log(err);
            })
    }
}

export default MonthlyReportController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/monthly_report/monthly_report.controller.js